import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as IconLocation } from '../../../../../assets/images/location.svg';
import { getCurrentPosition } from '../../../../../store/location';
import { loadersByName } from '../../../../../store/ui';
import Button, { ButtonKind } from '../../button/Button';

const LocationButton = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const loaderSearch = useSelector(loadersByName('searchNearMe'));
    const loaderLocation = useSelector(loadersByName('location'));

    return (
        <Button
            className={'search-filter__search--near-me-btn'}
            kind={ButtonKind.LINK}
            onClick={() => dispatch(getCurrentPosition())}
            disabled={loaderSearch || loaderLocation}
        >
            <IconLocation />
            {loaderSearch
                ? intl.formatMessage({ id: 'general.loading', defaultMessage: 'Wird geladen...' })
                : intl.formatMessage({ id: 'searchFilter.nearBtn', defaultMessage: 'in meiner Nähe' })}
        </Button>
    );
};

export default LocationButton;
